import { Module, MutationTree } from 'vuex'
import { Mutations, LineInfoState } from '@/interfaces/store/lineInfo'
import { RootState } from '@/interfaces/store/root'
import { LineProfile } from '@/interfaces/line-info'

export const state: LineInfoState = {
  idToken: undefined,
  profile: {
    displayName: undefined,
    pictureUrl: undefined,
    statusMessage: undefined,
    userId: undefined
  },
  socialToken: undefined,
}

export const mutations: MutationTree<LineInfoState> & Mutations = {
  updateLineProfile(state: LineInfoState, lineProfile: LineProfile) {
    state.profile = lineProfile
  },
  updateLineIdToken(state: LineInfoState, idToken: string) {
    state.idToken = idToken
  },
  updateLineSocialToken(state: LineInfoState, socialToken: string) {
    state.socialToken = socialToken
  },
}

export const store: Module<LineInfoState, RootState> = {
  namespaced: true,
  state,
  mutations,
}
